// extracted by mini-css-extract-plugin
module.exports = {"container":"lF8Fv","icon-spacer":"_2FB6v","iconSpacer":"_2FB6v","icon":"_2_MY-","button":"dzPrM"};